package uz.mint.frontend.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Input
import uz.mint.frontend.toSitePalette
import uz.mint.frontend.widthCss

/**
 * The destination search field, shared by the landing section and the full catalogue.
 *
 * One implementation so the two cannot drift: a customer who types "турц" on the landing page and
 * the same letters on `/plans` must narrow the same list the same way.
 *
 * @param maxWidth CSS width expression. The landing page sits it in the heading row where the
 *   category tabs used to be, so it is capped; the catalogue gives it more room under the title.
 */
@Composable
fun SearchBox(
    placeholder: String,
    query: String,
    maxWidth: String = "min(100%, 340px)",
    onQuery: (String) -> Unit,
) {
    val palette = ColorMode.current.toSitePalette()

    Row(
        Modifier
            .widthCss(maxWidth)
            .gap(10.px)
            .border(2.px, LineStyle.Solid, palette.rule)
            .backgroundColor(palette.card)
            .padding(topBottom = 12.px, leftRight = 16.px),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        SearchIcon(color = palette.ink2)
        Input(
            type = InputType.Text,
            attrs = Modifier
                .flex(1).minWidth(0.px)
                .border(0.px, LineStyle.None, palette.rule)
                .backgroundColor(Colors.Transparent)
                .color(palette.ink)
                .fontSize(15.px).fontWeight(FontWeight.SemiBold)
                .outline(0.px, LineStyle.None, palette.rule)
                .fontFamily("inherit")
                .toAttrs {
                    value(query)
                    attr("placeholder", placeholder)
                    attr("aria-label", placeholder)
                    onInput { onQuery(it.value) }
                }
        )
    }
}
